import {Component, HostBinding} from '@angular/core';
import {BrowserTabService} from '../../browser-tab/browser-tab.service';
import {AuthorizationService} from '../../authorization/authorization.service';
import {UserBalanceService} from '../user-balance.service';

@Component({
  selector: 'app-desktop-top-menu',
  templateUrl: './desktop-top-menu.component.html',
})
export class DesktopTopMenuComponent {
  @HostBinding('class.top-menu-desktop') desktopTopMenuComponent = true;

  constructor(
    public authorizationService: AuthorizationService,
    public browserTabService: BrowserTabService,
    public userBalance: UserBalanceService,
  ) {
  }
}
